import * as types from '../actiontypes';
import {promiseAreas} from '../../util/uiconstants';

export function getAllAdminUsers(url) {
	return {
		type: types.GET_ADMIN_USERS,
		meta: {
			api: {
				url: url,
				method: 'GET',
				trackWithArea: promiseAreas.GET_ADMIN_USERS
			}
		}
	};
}
export function clearAllAdminUsers(url) {
	return {
		type: types.CLEAR_ADMIN_USERS
	};
}

export function createAdminUser(url, payload) {
	return {
		type: types.CREATE_ADMIN_USER,
		meta: {
			api: {
				url: url,
				method: 'POST',
				data: payload,
				trackWithArea: promiseAreas.CREATE_ADMIN_USER
			}
		},
		payload: payload
	};
}

export function getAdminUser(url, payload) {
	return {
		type: types.GET_ADMIN_USER,
		meta: {
			api: {
				url: url,
				method: 'GET',
				trackWithArea: promiseAreas.GET_MANAGE_USER
			}
		},
		payload
	};
}
export function clearAdminUser() {
	return {
		type: types.CLEAR_ADMIN_USER
	};
}

export function getAdminUserProject(url, payload) {
	return {
		type: types.GET_ADMIN_USER_PROJECT,
		meta: {
			api: {
				url: url,
				method: 'GET',
				trackWithArea: promiseAreas.USER_PROJECTS_AREA
			}
		},
		payload
	};
}
export function getAdminUserClient(url) {
	return {
		type: types.GET_ADMIN_USER_CLIENT,
		meta: {
			api: {
				url: url,
				method: 'GET',
				trackWithArea: promiseAreas.GET_MANAGE_USER
			}
		}
	};
}

export function getAdminUserOtherProject(url) {
	return {
		type: types.GET_ADMIN_USER_OTHER_PROJECT,
		meta: {
			api: {
				url: url,
				method: 'GET',
				trackWithArea: promiseAreas.OTHER_PROJECTS_AREA
			}
		}
	};
}
export function setAdminUserActiveTab(tab) {
	return {
		type: types.SET_ADMIN_USER_ACTIVE_TAB,
		tab
	};
}

export function setIsUnsavedUserDataModalOpen(isUnsavedUserDataModalOpen) {
	return {
		type: types.SET_IS_UNSAVED_USER_DATA,
		isUnsavedUserDataModalOpen
	};
}
